export const CHART_DEFAULT_PLOT_TYPE = "lines+markers";
export const ChartFormatOptions = ["Single", "Multiplot", "Multi-Y"];
export const LiveChartRefreshInterval = 1000 * 10; // 15 seconds
export const MAX_TAGS_COUNT = 15;
export const MAX_MULTI_Y_TAGS_COUNT = 5;
export const LIVE_CHART = "Live (Data for Past 15 min)";
export const TagColorOptions = [
  {
    name: "Teal",
    code: "#128370"
  },
  {
    name: "Pink",
    code: "#FC2D72"
  },
  {
    name: "Orange",
    code: "#FF9E19"
  },
  {
    name: "Green",
    code: "#58B947"
  },
  {
    name: "Blue",
    code: "#00A9E0"
  },
  {
    name: "Purple",
    code: "#5F259F"
  },
  {
    name: "Light Pink",
    code: "#FFA3CA"
  },
  {
    name: "Dark Blue",
    code: "#004c97"
  },
  {
    name: "Light Orange",
    code: "#FFCD00"
  },
  {
    name: "Light Green",
    code: "#A4D65E"
  },
  {
    name: "Light Teal",
    code: "#6DD8CD"
  },
  {
    name: "Light Blue",
    code: "#8BDCF9"
  },
  {
    name: "Light Purple",
    code: "#AD87F7"
  },
  {
    name: "Vivid Purple",
    code: "#C900E3"
  },
  {
    name: "Brown",
    code: "#844700"
  }
];
export const ChartRangeInHrs = {
  "15 minute": 0.25,
  "1 hour": 1,
  "12 hour": 12,
  "1 day": 24,
  "1 week": 7 * 24,
  "2 week": 14 * 24,
  "1 month": 30 * 24
};

export const GRAPH_DURATIONS = {
  [LIVE_CHART]: "15 minute",
  "Past 1 hour": "1 hour",
  "Past 12 hours": "12 hour",
  "Past 1 day": "1 day",
  "Past 1 week": "1 week",
  "Past 2 weeks": "2 week",
  "Past 1 month": "1 month",
  "Past 3 months": "3 month",
  "Past 6 months": "6 month",
  Custom: "custom"
};
export const CHART_DURATIONS = (chartDurations => {
  delete chartDurations["Past 6 months"];
  delete chartDurations["Past 3 months"];
  return chartDurations;
})({ ...GRAPH_DURATIONS });

export const TIMESERIES_INTERVAL_GROUP = {
  "15 minute": 5,
  "1 hour": 15,
  "12 hour": 60,
  "1 day": 120, // unit/60 = seconds => 120/60 = 2 seconds interval
  "1 week": 180,
  "2 week": 300,
  "1 month": 600,
  custom: 1200
};

export const CHART_HEADER_ACTIONS = {
  NONE: "NONE",
  EDIT_TAGS: "EDIT_TAGS",
  EDIT_ALARMS: "EDIT_ALARMS",
  ADD_NORMALIZE_TAG: "ADD_NORMALIZE_TAG",
  EDIT_NORMALIZE_FILTERS: "EDIT_NORMALIZE_FILTERS",
  SINGLE_PLOT: "SINGLE_PLOT",
  MULTI_Y_PLOT: "MULTI_Y_PLOT",
  MULTI_PLOT: "MULTI_PLOT",
  DOWNLOAD_TAGS_DATA: "DOWNLOAD_CSV"
};

export const CHART_PLOT_FORMATS = {
  SINGLE_PLOT: "Single",
  MULTI_Y_PLOT: "Multi-Y",
  MULTI_PLOT: "Multiplot"
};

const ChartConstant = {
  CHART_DEFAULT_PLOT_TYPE,
  ChartFormatOptions,
  LiveChartRefreshInterval,
  MAX_TAGS_COUNT,
  MAX_MULTI_Y_TAGS_COUNT,
  LIVE_CHART,
  TagColorOptions,
  ChartRangeInHrs,
  CHART_DURATIONS,
  TIMESERIES_INTERVAL_GROUP,
  CHART_HEADER_ACTIONS,
  CHART_PLOT_FORMATS,
  GRAPH_DURATIONS
};

export default ChartConstant;
